import getPageUrl from "./getPageUrl";

export default getPageUrl;
